import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {ServiceRequest} from '../../back-office/Models/ServiceRequest';
import {MenuItems} from '../../shared/menu-items/menu-items';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ServiceRequestService {

  public serviceRequest: BehaviorSubject<ServiceRequest> = new BehaviorSubject<ServiceRequest>(new ServiceRequest());

  constructor(
    private helper: Helper,
    private http: HttpClient,
    private menuItems: MenuItems
  ) {
  }


  public getServices(gridData = new HttpParams(), scope = 'dealer-system') {
    this.fetchNotificationsCount();
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/service-request/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceSubjects(gridData = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/service-request/service-subjects?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceRequestStatuses(gridData = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/service-request/statuses?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public confirmStep(data) {
    return this.http.post<any>(environment.apiUrl + '/dealer-system/service-request/confirm-step', data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public fetchServiceRequestComplete(requestId, complete = true, scope = 'dealer-system') {
    if (complete) {
      this.serviceRequest.next(new ServiceRequest());
    }

    return this.http.get<ServiceRequest>(
      environment.apiUrl + '/' + scope + '/service-request/' + requestId
    ).pipe(catchError(res => this.helper.catchError(res))).subscribe((res: ServiceRequest) => {
      this.fetchNotificationsCount();
      this.serviceRequest.next(res);
    });
  }

  public newServiceRequest(serviceRequest) {
    return this.http.post<any>(environment.apiUrl + '/dealer-system/service-request/new', {serviceRequest: serviceRequest})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public fetchNotificationsCount() {
    this.http.get<any>(environment.apiUrl + '/dealer-system/service-request/notifications-count')
      .pipe(catchError(res => this.helper.catchError(res))).subscribe((data) => {
      this.menuItems.setServiceBadge(data);
    });
  }
}
